import React from "react";

const Scroll = (props) => {
  return (
    <div
      style={{
        overflowY: "scroll",
        border: "1px solid white",
        height: "300px",
        scrollMarginBottom: "30px"
      }}
    >
      {props.children}
    </div>
  );
};

export default Scroll;
